export default {
  // START:: SET APP THEME
  setAppTheme(state, payload) {
    state.asass_provider_dashboard_theme = payload;
  },
  // END:: SET APP THEME
};
